module.exports = __webpack_public_path__ + "img/05-JS-craft-your-resume.be9b0e37.svg";